module.exports = __webpack_public_path__ + "img/vue2-renfort_rose.50bc49a8.png";